import { apiFetch } from '@/lib/api';

export interface AssistantConfiguration {
  method_ref: string | null;
  doma_refs: string[];
  default_model_ref: string | null;
}
export interface PracticeRoom {
  id: string;
  owning_tenant: string;
  practice_key: string;
  state: 'closed';
  version: number;
  assistant_configuration: AssistantConfiguration;
  opening_confirmation: boolean;
  explicit_share_refs: string[];
  preparation: 'incomplete' | 'configured';
  missing_references: string[];
  integration: 'deferred';
}
export interface PracticePolicy {
  practice_key: string;
  version: number;
  settings: Record<string, string | string[] | number | boolean | null>;
  effective_settings: PracticePolicy['settings'];
  activation: 'deferred';
  can_edit?: boolean;
}
export interface PracticeList {
  rooms: PracticeRoom[];
  practices: Record<string, string>;
  offset: number;
  limit: number;
}
const base = '/api/v1/practices';
export const practicesApi = {
  list: (): Promise<PracticeList> => apiFetch(base),
  create: (): Promise<PracticeRoom> => apiFetch(`${base}/workshop/rooms`, { method: 'POST' }),
  get: (id: string): Promise<PracticeRoom> => apiFetch(`${base}/rooms/${encodeURIComponent(id)}`),
  save: (room: PracticeRoom, openingConfirmation: boolean): Promise<PracticeRoom> =>
    apiFetch(`${base}/rooms/${encodeURIComponent(room.id)}`, {
      method: 'PUT',
      body: JSON.stringify({ version: room.version, assistant_configuration: room.assistant_configuration, opening_confirmation: openingConfirmation }),
    }),
  policy: (): Promise<PracticePolicy> => apiFetch(`${base}/workshop/policy`),
  savePolicy: (policy: PracticePolicy): Promise<PracticePolicy> =>
    apiFetch(`${base}/workshop/policy`, { method: 'PUT', body: JSON.stringify({ version: policy.version, settings: policy.settings }) }),
};
